import { render, staticRenderFns } from "./Fa2Approve.vue?vue&type=template&id=fe6e7284"
import script from "./Fa2Approve.vue?vue&type=script&lang=js"
export * from "./Fa2Approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports